import {putMethod} from '~/api'

async function put(id, request) {
    return await putMethod(`/api/cancelManualInvoice/${id}`, request)
}

export {put}
